import { FilterConstants } from '../../shared/constants/filter-constants';

/* Shared by the sidebar (NavDrawerComponent) and the topbar search, so both cluster and
   navigate the backend menu the same way. */

/* Visual-only grouping of the real backend menu (dataManager.menuArray stays a flat,
   permission-filtered list — this only clusters it under section labels, mirroring
   design/prototype/assets/shell.js GROUPS). A name the map doesn't recognise still
   renders, just under a trailing "More" group, so a new backend menu item never
   silently disappears. */
export const NAV_GROUPS: { label: string; names: string[] }[] = [
  { label: 'Overview', names: ['home'] },
  { label: 'Payments', names: ['transactions', 'payments', 'digital wallet', 'disputes', 'deposits', 'ach returns', 'risk management', 'vamp details'] },
  { label: 'Customers', names: ['customers', 'subscriptions'] },
  { label: 'Reports', names: ['statements', 'reports', 'ai reports'] },
  { label: 'Developer', names: ['api', 'bridge'] },
  { label: 'Account', names: ['merchant profile', 'events & logs'] },
  { label: 'Support', names: ['support tickets', 'zendesk tickets', 'knowledge base', 'payarc assist'] }
];

export const NAV_GROUP_FALLBACK = 'More';

/** Section label for a backend menu name, e.g. 'Deposits' → 'Payments'. */
export function navGroupLabel(menuName: string): string {
  const name = (menuName || '').toLowerCase();
  const group = NAV_GROUPS.find(g => g.names.indexOf(name) > -1);
  return group ? group.label : NAV_GROUP_FALLBACK;
}

/* Saved list-screen filters. Navigating from the menu clears them so a list opens unfiltered. */
const LIST_FILTER_STORAGE_KEYS: string[] = [
  FilterConstants.SUBSCRIPTION_FILTER_COUNT_STORAGE_KEY,
  FilterConstants.SUBSCRIPTION_FILTER_STORAGE_KEY,
  FilterConstants.PAYOUTS_FILTER_COUNT_STORAGE_KEY,
  FilterConstants.PAYOUTS_FILTER_STORAGE_KEY,
  FilterConstants.PAYMENT_FILTER_COUNT_STORAGE_KEY,
  FilterConstants.PAYMENT_FILTER_STORAGE_KEY,
  FilterConstants.TRANSACTIONS_FILTER_COUNT_STORAGE_KEY,
  FilterConstants.TRANSACTIONS_FILTER_STORAGE_KEY,
  FilterConstants.INVOICE_FILTER_COUNT_STORAGE_KEY,
  FilterConstants.INVOICE_FILTER_STORAGE_KEY,
  FilterConstants.COUPON_FILTER_COUNT_STORAGE_KEY,
  FilterConstants.COUPON_FILTER_STORAGE_KEY,
  FilterConstants.CYCLE_FILTER_COUNT_STORAGE_KEY,
  FilterConstants.CYCLE_FILTER_STORAGE_KEY,
  FilterConstants.DISPUTE_FILTER_COUNT_STORAGE_KEY,
  FilterConstants.DISPUTE_FILTER_STORAGE_KEY,
  FilterConstants.CUSTOMER_FILTER_COUNT_STORAGE_KEY,
  FilterConstants.CUSTOMER_FILTER_STORAGE_KEY,
  FilterConstants.DISPUTE_REPORT_FILTER_STORAGE_KEY,
  FilterConstants.DISPUTE_REPORT_FILTER_COUNT_STORAGE_KEY,
  FilterConstants.REVIEW_FILTER_STORAGE_KEY,
  FilterConstants.REVIEW_FILTER_COUNT_STORAGE_KEY,
  FilterConstants.PAYMENT_INVOICE_FILTER_STORAGE_KEY,
  FilterConstants.PAYMENT_INVOICE_FILTER_COUNT_STORAGE_KEY,
  'customer_data' // BaseComponent.CUSTOMER_DATA
];

/** Removes every saved list filter. Pass the app's 'LOCALSTORAGE' instance; browser only. */
export function clearListFilters(storage: Pick<Storage, 'removeItem'>): void {
  LIST_FILTER_STORAGE_KEYS.forEach(key => storage.removeItem(key));
}
